// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@conklin/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { orderSummaryStyles } from "@conklin/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationOrderSummary";
import { color } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

orderSummaryStyles.messageText = {
    ...orderTotalDisplaySharedStyles.microCopyText,
};
orderSummaryStyles.divider = {
    css: css`
        margin-top: 12px;
        border-top: 1px solid ${color("common.border")};
        width: 100%;
        height: 1px;
    `,
};
